import React, { useEffect, useState } from 'react'
import { CircleCheckIcon } from '../../../../Icons/CircleCheckIcon'
import { StyledCircleCheckIconWrapper } from './StyledCircleCheckIconWrapper'
import { useTranslation } from 'react-i18next'

const AttributesCheck = ({ baseData }) => {
    const [isValid, setIsValid] = useState(false)
    const { t } = useTranslation()

    useEffect(() => {
        if (!!baseData.isLocked || !!baseData.isObsolet || !!baseData.isAvailableMale || !!baseData.isAvailableFeMale || !!baseData.class.isWithSizes) {
            setIsValid(true)
        } else {
            setIsValid(false)
        }
    }, [baseData])

    return (
        <>
            <StyledCircleCheckIconWrapper>
                <CircleCheckIcon variant={isValid ? 'optional' : 'none'} />
            </StyledCircleCheckIconWrapper>
            <span>{t('articleAdmin:attributesData')}</span>
        </>
    )
}

export default AttributesCheck